import { render } from "./ServiceVue.vue?vue&type=template&id=33bc4b0e&scoped=true"
import script from "./ServiceVue.vue?vue&type=script&lang=js"
export * from "./ServiceVue.vue?vue&type=script&lang=js"

import "./ServiceVue.vue?vue&type=style&index=0&id=33bc4b0e&scoped=true&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33bc4b0e"]])

export default __exports__